var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.40901 3.40918C1.83097 2.98722 2.40326 2.75017 3 2.75017H8.25C8.66421 2.75017 9 3.08596 9 3.50017C9 3.91438 8.66421 4.25017 8.25 4.25017H3C2.80109 4.25017 2.61032 4.32919 2.46967 4.46984C2.32902 4.61049 2.25 4.80126 2.25 5.00017V15.5002C2.25 15.6991 2.32902 15.8898 2.46967 16.0305C2.61032 16.1712 2.80109 16.2502 3 16.2502H13.5C13.6989 16.2502 13.8897 16.1712 14.0303 16.0305C14.171 15.8898 14.25 15.6991 14.25 15.5002V10.2502C14.25 9.83596 14.5858 9.50017 15 9.50017C15.4142 9.50017 15.75 9.83596 15.75 10.2502V15.5002C15.75 16.0969 15.5129 16.6692 15.091 17.0912C14.669 17.5131 14.0967 17.7502 13.5 17.7502H3C2.40326 17.7502 1.83097 17.5131 1.40901 17.0912C0.987053 16.6692 0.75 16.0969 0.75 15.5002V5.00017C0.75 4.40343 0.987053 3.83114 1.40901 3.40918Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 2.65918C14.777 2.65918 14.563 2.74778 14.4053 2.9055L7.42722 9.88361L7.03078 11.4694L8.61656 11.0729L15.5947 4.09484C15.7524 3.93712 15.841 3.72321 15.841 3.50017C15.841 3.27713 15.7524 3.06322 15.5947 2.9055C15.437 2.74778 15.223 2.65918 15 2.65918ZM13.3447 1.84484C13.7837 1.40582 14.3791 1.15918 15 1.15918C15.6209 1.15918 16.2163 1.40582 16.6553 1.84484C17.0944 2.28386 17.341 2.8793 17.341 3.50017C17.341 4.12104 17.0944 4.71648 16.6553 5.1555L9.53033 12.2805C9.43421 12.3766 9.31378 12.4448 9.1819 12.4778L6.1819 13.2278C5.92632 13.2917 5.65596 13.2168 5.46967 13.0305C5.28338 12.8442 5.2085 12.5738 5.27239 12.3183L6.02239 9.31827C6.05536 9.18639 6.12355 9.06596 6.21967 8.96984L13.3447 1.84484Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.546091be21de16924147740b68782af6.svg";
export { ForwardRef as ReactComponent };